import {Comparator} from "./comparator.interface";
import {ArrayHelper} from "../helpers/array.helper";
import {comparator} from "../decorators/comparator.decorator";

@comparator(Array)
export class ArrayComparator<T = any> implements Comparator<Array<T>> {

    isEqualTo(value1: Array<T> | null, value2: Array<T> | null): boolean {
        return ArrayHelper.isEqual(value1, value2);
    }

}